export default "__VITE_ASSET__D76eiV6Q__"